<template>
    <div class="card card-small" v-if="fetched">
        <status-legend class="border-bottom"></status-legend>
        <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0 responsive-table vam">
                <thead class="bg-light">
                <tr>
                    <th scope="col" class="border-0 id-cell">Nr umowy</th>
                    <th scope="col" class="border-0">Spółka</th>
                    <th scope="col" class="border-0">Kwota pożyczki (w tym prowizja)</th>
                    <th scope="col" class="border-0">Prowizja</th>
                    <th scope="col" class="border-0">Koszty dodatkowe</th>
                    <th scope="col" class="border-0">Odsetki umowne</th>
                    <th scope="col" class="border-0">Odsetki karne</th>
                    <th scope="col" class="border-0">Kwota końcowa</th>
                    <th scope="col" class="border-0" style="width: 220px;">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="contract in schedules"
                    :class="[
                        { 'bg-light-orange' : contract.installment_due && contract.status == 'during' },
                        { 'bg-light-red': contract.status == 'terminated' },
                        { 'is-archive': contract.is_archive !== 0},
                        { 'archive-accepted': contract.is_archive === 1},
                        { 'bg-green': contract.is_archive === 0 && contractIsPaid(contract)}
                    ]">
                    <td class="id-cell" >
                        <span class="status-border" :style="[{ 'backgroundColor' : borderColorFromStatus(contract) }]"></span>
                        <dt>Nr umowy</dt>
                        <dd>
                            <ss-popover  v-if="contract.terminated_date" variant="right" class="terminated-info">
                                <template slot="tooltip">Umowa wypowiedziana<br />dnia: <strong>{{contract.terminated_date}}</strong></template>
                            </ss-popover>
                            <span class="cell-content">
                                {{ contract.contract_number }}
                                <ss-popover
                                    v-if="contract.incomplete_instructions === 1"
                                    class="danger-popover">
                                    <d-badge theme="danger" class="circle-pill" pill>
                                        <i class="fa fa-exclamation"></i>
                                    </d-badge>
                                    <template slot="tooltip">
                                        Niekompletne dyspozycje wypłaty
                                    </template>
                                </ss-popover>
                            </span>
                        </dd>
                        <dd>
                            <d-badge
                                v-if="contract.include_vat === 1"
                                theme="success"
                                class="mb-2"
                            >Umowa z VAT</d-badge>
                        </dd>
                    </td>
                    <td>
                        <dt>Spółka:</dt>
                        <dd v-if="!contract.company_name">Brak</dd>
                        <dd v-else><a :href="$router.resolve({name: 'company-edit', params: {id: contract.company_id}}).href" target="_blank">{{ contract.company_name }}</a></dd>
                    </td>
                    <td>
                        <dt>Kwota pożyczki (w tym prowizja)</dt>
                        <dd>{{ toNumber(contract.loan_amount + contract.final_provision) }} zł</dd>
                    </td>
                    <td>
                        <dt>Prowizja</dt>
                        <dd>{{ toNumber(contract.final_provision) }} zł</dd>
                    </td>
                    <td>
                        <dt>Koszty dodatkowe</dt>
                        <dd>{{ toNumber(contract.additional_costs) }} zł</dd>
                    </td>
                    <td>
                        <dt>Odsetki umowne</dt>
                        <dd>{{ toNumber(contract.interest_sum) }} zł</dd>
                    </td>
                    <td>
                        <dt>Odsetki karne</dt>
                        <dd>{{ toNumber(contract.interest_penalty_sum) }} zł</dd>
                    </td>
                    <td>
                        <dt>Kwota końcowa</dt>
                        <dd>{{ toNumber(contract.loan_final_sum) }} zł</dd>
                    </td>
                    <td>
                        <dt>Akcje</dt>
                        <dd>
                            <div
                                v-if="!contractIsPaid(contract) && !contract.close_date && !contract.draft != '0'"
                                class="ss-date-wrapper w-100">
                                <d-button
                                    @click.prevent=""
                                    theme="success"
                                    class="mb-2">
                                    <i class="material-icons">add</i> dodaj&nbsp;wpłatę
                                </d-button>
                                <ss-date
                                    @picked="contractPaid(contract)"
                                    type="text"
                                    name="first_installment_date"
                                    v-model="paid_date"
                                    placeholder=""/>
                            </div>
                            <d-button
                                @click.prevent="edit(contract)"
                                class="mx-2">
                                <i class="material-icons">search</i> Pokaż
                            </d-button>
                            <d-button
                                v-if="getUser.is_admin === 1"
                                @click.prevent="removeContract(contract.id)"
                                theme="danger"
                                class="mx-2">
                                <i class="material-icons">delete</i> Usuń
                            </d-button>
                        </dd>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="schedules.length < 1" class="text-info">Brak umów do wyświetlenia.</p>
        </div>

        <ss-modal
                v-show="paid_installment_modal"
                title="Title"
                intro="bounceIn"
                outro ="bounceOut">
            <!-- HEADER -->
            <div slot = "modal-header">
                Podaj kwotę wpłaty
            </div>
            <!-- BODY -->
            <div slot = "modal-body" class="text-center">
                <d-col md="6" offset-md="3">
                    <ss-price-input class="{ disabled : submitting_payment }" v-model="amount" />
                </d-col>
            </div>
            <!-- FOOTER -->
            <div slot = "modal-footer">
                <d-button @click.prevent="closeModal" :class="{ disabled : submitting_payment }" theme="danger">Anuluj</d-button>
                <d-button @click.prevent="contractPaidSubmit" :class="{ isLoading: submitting_payment }" theme="success" class="ml-3">Potwierdź</d-button>
            </div>
        </ss-modal>
    </div>
</template>

<script>
    import FileSaver from 'file-saver'
    import SsDate from  '../common/SsDate'
    import ColorUtils from  '../../utils/colors'
    import SsModal from '../common/SsModal'
    import SsPriceInput from '../common/SsPriceInput'
    import SsPagination from '../common/SsPagination'
    import StatusLegend from '../common/StatusLegend'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "ContractsList",
        components: {
            SsDate,
            StatusLegend,
            SsModal,
            SsPriceInput,
            SsPagination
        },
        props: {
            props: {
                type: Array,
                default: ()=>[]
            }
        },
        data(){
            return{
                submitting_payment: false,
                contract_id: '',
                amount: '',
                paid_installment_modal: false,
                schedules: [],
                paid_date: '',
                fetched: true,
            }
        },
        computed: {
            ...mapGetters([
                'allCompanies',
                'getUser'
            ])
        },
        methods: {
            ...mapActions([
                'getAllCompanies'
            ]),
                companyById(id){
                let company = this.allCompanies.length > 0 ? this.allCompanies.find(x => x.id === id) : this.allCompanies.length;
                return company ? company.name : '';
            },
            closeModal(){
                this.paid_installment_modal = false;
                this.$nextTick(function () {
                    this.paid_date = Vue.getCurrentDate();
                })
            },
            borderColorFromStatus(schedule){
                return schedule.status ? ColorUtils.status[schedule.status] : 'transparent';
            },
            toNumber(number){
                return Vue.toNumber(number);
            },
            edit(con){
                this.$emit('editSchedule', con);
            },
            contractIsPaid(contract){
              return contract.to_finish_credit <= 0
            },
            contractPaid(contract){
                this.contract_id = contract.id;
                this.paid_installment_modal = true;
            },
            contractPaidSubmit(force){
                this.submitting_payment = true;
                if(force !== 1){
                    force = 0;
                }
                axios.post('api/schedules/partial-payment', {
                    schedule_id: this.contract_id,
                    paid_date: this.paid_date,
                    amount: this.amount,
                    force: force
                }).then(response => {
                    this.closeModal();
                    this.submitting_payment = false;
                    if (response.data.status === 0) {
                        if(response.data.overpayment === 1){
                            Vue.swal({
                                type: 'warning',
                                title: response.data.message,
                                showCancelButton: true,
                                confirmButtonText: 'Tak',
                                cancelButtonText: 'Anuluj',
                                buttonsStyling: true
                            }).then((answer) => {
                                if(answer.value){
                                    this.contractPaidSubmit(1);
                                }
                            });
                        }
                        else{
                            Vue.swal({
                                type: 'error',
                                title: response.data.message,
                                showConfirmButton: true,
                            }).then(() => {});
                        }
                    } else {
                        Vue.swal({
                            type: 'success',
                            title: 'Płatność została zapisana.',
                            showConfirmButton: true,
                        }).then(() => {
                            this.$emit('removeContract');
                        });
                    }
                }).catch((errors) =>{
                    this.submitting_payment = false;
                    this.closeModal();
                    Vue.swal({
                        type: 'warning',
                        title: 'Wystąpił błąd',
                        text: 'Spróbuj ponownie później',
                        showConfirmButton: true,
                    });
                })
            },
            removeContract(id){
                Vue.swal({
                    title: 'Uwaga',
                    html: 'Czy potwierdzasz usunięcie wybranej umowy?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Nie',
                    buttonsStyling: true
                }).then((logout) => {
                    if(logout.value){
                        axios.post('api/schedules/remove-schedule', {
                            id: id
                        }).then(response => {
                            this.$emit('removeContract', id);
                            Vue.swal({
                                type: 'success',
                                title: 'Umowa została usunięta.',
                                showConfirmButton: true,
                            });
                        }).catch((errors) =>{
                            console.log(errors);
                        })
                    }
                }).catch((errors) =>{
                    console.log(errors);
                })
            }
        },
        mounted(){
            this.schedules = this.props;
            this.fetched = true;
            this.paid_date = Vue.getCurrentDate();
            this.getAllCompanies();
        },
        watch: {
            props: {
                handler: function(to) {
                    this.schedules = to;
                },
                deep: true
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-cell dd{
        white-space: nowrap;
        text-align: right;
    }
    .table{
        border-spacing: 0;
    }

    .id-cell{
        position: relative;
        width: 150px;

        .cell-content {
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            gap: 5px;
            justify-content: center;
        }

        .danger-popover {
            display: flex;
            z-index: 1000;

            .circle-pill.badge.badge-pill {
                font-size: 65%;
                height: 20px;
                margin: auto;
                width: 20px;
            }
        }
    }
</style>
